import styled from "styled-components";

/**
 * The picker that sits under the article inside the Guides dialog (ui#1555).
 *
 * Nothing new visually: the rows are `Prose`'s own list and link rules, the same ones the related and
 * corpus blocks on a content page already draw. All this adds is the rule above it separating the
 * article from the list, a treatment for the guide currently being read — which is `aria-current` on
 * the anchor, so what a screen reader announces and what a sighted reader sees are one fact — and a
 * touch band, explained below.
 */
export const GuideIndex = styled.nav`
	margin-top: 34px;
	padding-top: 22px;
	border-top: 1px solid ${({theme}) => theme.tokens.line};

	a[aria-current] {
		color: ${({theme}) => theme.tokens.ink};
		font-weight: 700;
		text-decoration: none;
	}

	/*
	 * On a phone these rows are CONTROLS, not passing references: picking one is the whole point of the
	 * sheet. At the prose metric a single-line title is a 19px tap target, which is under the 44px this
	 * app holds every other control to, so below the same 640px band the sheet itself switches on the
	 * anchors become block rows with their own padding and the list's own gap goes away, leaving one
	 * contiguous 45px row per guide. Desktop keeps the prose rhythm untouched, and the related-links
	 * list above stays as it is everywhere else in the app - it lists references, not choices.
	 */
	@media (max-width: 640px) {
		li {
			margin: 0;
		}

		a {
			display: block;
			padding: 13px 0;
		}
	}
`;
